import React from 'react'
import { CSSTransition } from 'react-transition-group'

type CSSTransitionProps = Pick<
  React.ComponentProps<typeof CSSTransition>,
  'onExited'
>

interface ModalTransitionProps extends CSSTransitionProps {
  show: boolean
}

const ModalTransition: React.FC<ModalTransitionProps> = ({
  show: showModal,
  ...props
}) => (
  <CSSTransition
    timeout={300}
    mountOnEnter
    unmountOnExit
    in={showModal}
    classNames="modal"
    {...props}
  />
)

export default ModalTransition
